import React, { Fragment, memo, useMemo } from 'react';

import {
  findCitationByKey,
  hasCitationMarkers,
} from 'app/pages/loanApplication/components/GuidelineCitations/citationMarkers.utils';
import PropTypes from 'prop-types';

import { buildCitedTextSegments } from '../AiActivityCitations.utils';
import CitationChip from '../CitationChip';
import { useAiActivityCitations } from '../hooks/useAiActivityCitations';

// LEN-213: renders a plain string (a review-form value, a table cell, a transcript line)
// with each guideline-citation marker replaced in place by a citation chip. Text without
// markers is returned untouched.
const CitedText = ({ text = null }) => {
  const { citations, status } = useAiActivityCitations();
  const segments = useMemo(
    () => (hasCitationMarkers(text) ? buildCitedTextSegments(text) : null),
    [text],
  );

  if (!segments) {
    return text;
  }

  return segments.map(segment =>
    segment.type === 'citation' ? (
      <CitationChip
        citation={findCitationByKey(citations, segment.key)}
        citationKey={segment.key}
        key={segment.renderKey}
        status={status}
      />
    ) : (
      <Fragment key={segment.renderKey}>{segment.value}</Fragment>
    ),
  );
};

CitedText.propTypes = {
  text: PropTypes.string,
};

export default memo(CitedText);
